import { HomePage } from "./../home/home";
import { GoogleChartInterface } from "ng2-google-charts/google-charts-interfaces";
import { TranslateService } from "@ngx-translate/core";
import { Http, RequestOptions, Headers } from "@angular/http";
import { ServiceProvider } from "./../../providers/service/service";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  LoadingController,
  NavParams,
} from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-plaza-stat-merchant",
  templateUrl: "plaza-stat-merchant.html",
})
export class PlazaStatMerchantPage {
  data = {
    total_sales: "",
    merchants: [
      [
        {
          merchant_id: "",
          merchant_name: "",
          total_sales: "",
        },
      ],
    ],
  };
  merchants: any;
  data2 = {
    total_shoppers: "",
    merchants: [
      [
        {
          merchant_id: "",
          merchant_name: "",
          total_shoppers: "",
        },
      ],
    ],
  };
  theme = 1;

  public pieChart: GoogleChartInterface = {
    chartType: "PieChart",
    dataTable: this.navParams.data.stat_merchantPrice,
    opt_firstRowIsData: true,
    options: {
      title: "",
      pieSliceText: "value",
      legend: {
        position: "none",
        //  textStyle: {color: '#d59237', fontSize: 14},
        //  alignment: 'center',
        //  maxLines: 1
      },
      is3D: false,
      chartArea: {
        left: 0,
        top: 5,
        bottom: 5,
        width: "100%",
        height: "100%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      // width: '100%',
      backgroundColor: { fill: "transparent" },
      colors: [
        "#3d4c9f",
        "#3d8a43",
        "#408bca",
        "#a4d334",
        "#f796f7",
        "#ff924e",
      ],
      animation: {
        duration: 1000,
      },
    },
  };

  // public pieChart2: GoogleChartInterface = {
  //    chartType: 'PieChart',
  //    dataTable: [
  //       ['Merchant 1', 0],
  //       ['Merchant 2', 0],
  //       ['Merchant 3', 0]
  //    ],
  //    opt_firstRowIsData: true,
  //    options: {
  //       title: '',
  //       pieSliceText: 'value',
  //       legend: {
  //          position: 'none'
  //       //  textStyle: {color: '#d59237', fontSize: 14},
  //       //  alignment: 'center',
  //       //  maxLines: 1
  //       },
  //       'is3D':false,
  //       chartArea: {
  //          left:0,top:5, bottom: 5,width:'100%', height: '100%',
  //          strokeWidth: 1,
  //          stroke: '#d59237'
  //       },
  //       // width: '100%',
  //       backgroundColor: { fill:'transparent'},
  //       colors: ["#3d4c9f", "#3d8a43", "#408bca", "#a4d334","#f796f7","#ff924e"],
  //       animation:{
  //          duration: 1000
  //       },
  //    },
  // }

  public pieChart2: GoogleChartInterface = {
    chartType: "ColumnChart",
    dataTable: this.navParams.data.stat_merchantAmount,
    options: {
      title: "",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237'},
        // alignment: 'center',
        // maxLines: 1
      },
      bar: { groupWidth: "95%" },
      backgroundColor: { fill: "transparent" },
      isStacked: true,
      // colors: [
      //   "#3d4c9f",
      //   "#3d8a43",
      //   "#408bca",
      //   "#a4d334",
      //   "#f796f7",
      //   "#ff924e",
      // ],
      chartArea: {
        left: 20,
        top: 5,
        width: "100%",
        height: "90%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      height: 260,
      hAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        viewWindow: { min: 0 },
      },
      vAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        // ticks: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50]
      },
    },
  };

  public barChart2: GoogleChartInterface = {
    chartType: "ColumnChart",
    dataTable: this.navParams.data.stat_merchantAccumulateAmount,
    options: {
      title: "",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237'},
        // alignment: 'center',
        // maxLines: 1
      },
      bar: { groupWidth: "95%" },
      backgroundColor: { fill: "transparent" },
      isStacked: true,
      colors: ["#eb3732", "#814098", "#f3953e"],
      chartArea: {
        left: 20,
        top: 5,
        width: "100%",
        height: "90%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      height: 360,
      hAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        viewWindow: { min: 0 },
      },
      vAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        // ticks: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50]
      },
    },
  };

  public barChart: GoogleChartInterface = {
    chartType: "ColumnChart",
    dataTable: this.navParams.data.stat_merchantAccumulateBath,
    options: {
      title: "",
      legend: {
        position: "none",
        // textStyle: {color: '#d59237'},
        // alignment: 'center',
        // maxLines: 3
      },
      bar: { groupWidth: "95%" },
      backgroundColor: { fill: "transparent" },
      isStacked: true,
      colors: ["#eb3732", "#814098", "#f3953e"],
      chartArea: {
        left: 40,
        top: 5,
        width: "100%",
        height: "90%",
        strokeWidth: 1,
        stroke: "#d59237",
      },
      height: 360,
      hAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        viewWindow: { min: 0 },
      },
      vAxis: {
        gridlines: { color: "#d59237" },
        textStyle: { color: "#d59237" },
        // ticks: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50]
      },
    },
  };

  merchantAccumulateAmount: any;
  merchantAccumulateBath: any;
  merchantPrice: any;
  merchantAmount: any;
  merchantsTraffic: any;
  merchantAccumulateAmount_total = 0;
  merchantAccumulateBath_total = 0;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    public translateService: TranslateService,
    private loadingCtrl: LoadingController,
    public navParams: NavParams
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    // this.merchantAmount = this.navParams.data.stat_merchantAmount;
    // this.merchantPrice = this.navParams.data.stat_merchantPrice;
    // this.merchantAccumulateAmount = this.navParams.data.stat_merchantAccumulateAmount;
    // this.merchantAccumulateBath = this.navParams.data.stat_merchantAccumulateBath;

    // this.pieChart2.dataTable = this.merchantAmount;
    // this.pieChart.dataTable = this.merchantPrice;
    // this.barChart2.dataTable = this.merchantAccumulateAmount;
    // this.barChart.dataTable = this.merchantAccumulateBath;

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();

    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaStatMerchant;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.data = data;
            this.merchants = data.merchants;
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );

      var link2 = this.services.URLPlazaShopperTraffic;
      this.http
        .get(link2, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.data2 = data;
            this.merchantsTraffic = data.merchants;
          },
          (error) => {
            var response = JSON.parse(error._body);
            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });

    loader.dismiss();
  }

  backPage() {
    this.navCtrl.pop();
  }
  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(HomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/plaza-stat-merchant/plaza-stat-merchant.ts